import React from 'react'
import Link from 'next/link'
import styles from '../../styles/components/BlogCard.module.css'
import moment from 'moment/moment'

const BlogCard = ({ article }) => {
  return (
    <article className={`bg-light overflow-hidden br-3 h-100 ${styles.card}`}>
      <Link
        href={`/blog/${article.attributes.slug}`}
        legacyBehavior
      >
        <div className='d-flex flex-column h-100'>
          <div
            className="p-4 d-flex flex-column gap-3"
          >
            <div className='d-flex flex-row justify-content-between'>
              <h3 className="fw-semibold">
                {article.attributes.title}
              </h3>
              <span
                className='text-muted small d-none d-sm-inline'
                style={{ flexShrink: 0 }}
              >{moment(article.attributes.publishedAt).format('MMM DD hh:mma')}</span>
            </div>

            <div className='fs-5'>
              {article.attributes.description}
            </div>

            <div className='text-muted small d-block d-sm-none'>
              {moment(article.attributes.publishedAt).format('MMM DD hh:mma')}
            </div>
          </div>
        </div>
      </Link>
    </article>
  )
}

export default BlogCard
